// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from "./axios";
import { toast } from "sonner";
import { showError, showSuccess } from "../actions/globalActions";

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useWaiverStore = create(immer((set) => ({
  waivers: [],
  currentWaiver: null,
  isLoading: false,

  // Methods to manipulate the state
  setWaivers: (waivers) => {
    set((state) => {
      state.waivers = waivers;
    });
  },

  setCurrentWaiver: (waiver) => {
    set((state) => {
      state.currentWaiver = waiver;
    });
  },

  setLoading: (loading) => {
    set((state) => {
      state.isLoading = loading;
    });
  },

  // Asynchronous actions
  fetchWaiversByOrganization: async (organizationId) => {
    try {
      set((state) => {
        state.isLoading = true;
      });
      const { data } = await axios.get(`${baseUrl}/waivers/organization/${organizationId}`);
      set((state) => {
        state.waivers = data.result || data;
        state.isLoading = false;
      });
    } catch (error) {
      console.error("Error in fetchWaiversByOrganization:", error);
      set((state) => {
        state.isLoading = false;
      });
    }
  },

  fetchFinalizedWaiversByOrganization: async (organizationId) => {
    try {
      set((state) => {
        state.isLoading = true;
      });
      const { data } = await axios.get(`${baseUrl}/waivers/organization/${organizationId}?finalized=true`);
      set((state) => {
        state.waivers = data.result || data;
        state.isLoading = false;
      });
    } catch (error) {
      console.error("Error in fetchFinalizedWaiversByOrganization:", error);
      set((state) => {
        state.isLoading = false;
      });
    }
  },

  createWaiver: (getToken) => {
    return async (waiver = {}, cb = () => {}) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/waivers/d`, waiver, createAuthHeader(token));
        data?.error ? toast.error(data?.error) : toast.success(`Waiver created successfully!`);  
        cb && cb(data?.result);
        set((state) => {
          state.waivers.push(data.result);
        });
        
      } catch (error) {
        showError("Error", "Failed to create waiver");
        console.error("Error in createWaiver:", error);
      }
    }
  },

  updateWaiver: (getToken) => {
    return async (waiver = {}, cb = () => {}) => {
      try {
        const token = await getToken();
        const { data } = await axios.put(`${baseUrl}/waivers/d/${waiver._id}`, waiver, createAuthHeader(token));
        data?.error ? toast.error(data?.error) : toast.success(`Waiver updated successfully!`);  
        cb && cb(data?.result);
        set((state) => {
          const index = state.waivers.findIndex(w => w._id === waiver._id);
          if (index !== -1) {
            state.waivers[index] = data.result;
          }
          if (state.currentWaiver && state.currentWaiver._id === waiver._id) {
            state.currentWaiver = data.result;
          }
        });
        
      } catch (error) {
        showError("Error", "Failed to update waiver");
        console.error("Error in updateWaiver:", error);
      }
    }
  },

  deleteWaiver: (getToken) => {
    return async (waiver = {}, cb = () => {}) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(`${baseUrl}/waivers/d/${waiver._id}`, createAuthHeader(token));
        data?.error ? toast.error(data?.error) : toast.success(`Waiver deleted successfully!`);  
        cb && cb(data?.result);
        set((state) => {
          state.waivers = state.waivers.filter(w => w._id !== waiver._id);
          if (state.currentWaiver && state.currentWaiver._id === waiver._id) {
            state.currentWaiver = null;
          }
        });
        
      } catch (error) {
        showError("Error", "Failed to delete waiver");
        console.error("Error in deleteWaiver:", error);
      }
    }
  },

})));

export default useWaiverStore;
